import { TemplateFont } from 'old-store/types/templates';
import { createAction } from 'redux-act';

export const fetchTemplateFonts = createAction('FETCH_TEMPLATES');
export const fetchPhotobookFonts = createAction('FETCH_PHOTOBOOK_FONTS');
export const fetchTemplatesFontsSuccess = createAction<TemplateFont[]>();
export const fetchPhotoboksFontsSuccess = createAction<TemplateFont[]>();
export const setLoadedFonts = createAction<string[]>();
